import React from "react";
import { Box, Card, Grid, styled, Typography } from "@mui/material";
import CountUp from "react-countup";

import {
  PendingActionsRounded as PendingActionsRoundedIcon,
  DoDisturbOnRounded as DoDisturbOnRoundedIcon,
  AddTaskRounded as AddTaskRoundedIcon,
  HourglassFullRounded as HourglassFullRoundedIcon,
  PanToolRounded as PanToolRoundedIcon,
} from "@mui/icons-material";

const StyledCard = styled(Card)(({ theme }) => ({
  "&.MuiCard-root": {
    [theme.breakpoints.down("sm")]: {
      padding: "16px !important",
      flexDirection: "row",
      gap: "10px",
    },

    padding: "25px",
    borderRadius: "15px",
    display: "flex",
    flexDirection: "column",
    alignContent: "space-between",
    boxShadow: "0 0 8px 2px rgba(0,0,0,0.1) !important",
  },
}));

function PartnerInvestorStatCard({ getApi }) {
  const fillStatForA = getApi.filter((i) => {
    return i.status === "S";
  });
  const filStatForP = getApi.filter((i) => {
    return i.status === "P";
  });
  const filStatForD = getApi.filter((i) => {
    return i.status === "D";
  });
  const filStatForH = getApi.filter((i) => {
    return i.status === "H";
  });
  const [A, D, P, ALL, H] = [
    fillStatForA.length,
    filStatForD.length,
    filStatForP.length,
    getApi.length,
    filStatForH.length,
  ];

  const cardList = [
    {
      name: "Total Registration",
      count: ALL,
      bgColor: "#2838a6",
      svg: <HourglassFullRoundedIcon fontSize="large" />,
    },
    {
      name: "Total Approved",
      count: A,
      bgColor: "#28a745",
      svg: <AddTaskRoundedIcon fontSize="large" />,
    },
    {
      name: "Total Declined",
      count: D,
      bgColor: "#FF0000",
      svg: <DoDisturbOnRoundedIcon fontSize="large" />,
    },
    {
      name: "Total Pending",
      count: P,
      bgColor: "#ffa500",
      svg: <PendingActionsRoundedIcon fontSize="large" />,
    },
    {
      name: "Total In Hold",
      count: H,
      bgColor: "#0288d1",
      svg: <PanToolRoundedIcon fontSize="large" />,
    },
  ];

  return (
    <>
      <Grid
        container
        direction="row"
        spacing={5}
        md={12}
        sx={{ mb: "24px", width: "100%" }}
      >
        {cardList.map((item, index) => (
          <Grid item xs={12} md={3} key={index}>
            <StyledCard
              sx={{ backgroundColor: `${item.bgColor}` }}
              elevation={6}
            >
              <Box>
                <Box
                  sx={{ display: "flex", flexDirection: "row", gap: "10px" }}
                >
                  <Box sx={{ color: "white" }}>{item.svg}</Box>
                  <CountUp
                    style={{
                      fontSize: "26px",
                      color: "#f2f2f2",
                    }}
                    start={0}
                    end={item.count}
                    duration={1}
                  />
                </Box>
              </Box>

              <Box>
                <Typography
                  variant="body1"
                  sx={{ fontFamily: "Poppins-SemiBold", color: "#f2f2f2" }}
                >
                  {item.name}
                </Typography>
              </Box>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default PartnerInvestorStatCard;
